module.exports = __webpack_public_path__ + "img/744.0cc4c5be.jpg";